import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { DateFormat } from "../../../../../../constants";
import { DateHelper } from "../../../../../../helper";
import { VacationPersonalLeaveRequest } from "../../../../../../services/viags/vacation-personal.service";

interface VacationHistoryTableProps {
  data?: VacationPersonalLeaveRequest[];
  totalApproved?: number;
  totalPending?: number;
  loading?: boolean;
}

const VacationHistoryTable = ({
  data = [],
  totalApproved,
  totalPending,
  loading = false,
}: VacationHistoryTableProps) => {
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);

  const columns: ColumnsType<VacationPersonalLeaveRequest> = [
    {
      title: "STT",
      key: "stt",
      width: 80,
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Ngày tạo",
      dataIndex: "Recdate",
      key: "Recdate",
      width: 150,
      align: "center",
      render: (date: string) => {
        if (!date) return "-";
        return DateHelper.formatDateToString(date, { format: DateFormat.DD_MM_YYYY_HH_MM });
      },
    },
    {
      title: "Từ ngày",
      dataIndex: "FromDate",
      key: "fromDate",
      width: 150,
      align: "center",
      render: (date: string) => {
        if (!date) return "-";
        return DateHelper.formatDateToString(date, { format: DateFormat.DD_MM_YYYY_HH_MM });
      },
    },
    {
      title: "Đến ngày",
      dataIndex: "ToDate",
      key: "toDate",
      width: 150,
      align: "center",
      render: (date: string) => {
        if (!date) return "-";
        return DateHelper.formatDateToString(date, { format: DateFormat.DD_MM_YYYY_HH_MM });
      },
    },
    {
      title: "Tổng nghỉ",
      children: [
        {
          title: (
            <span>
              Đã duyệt {data.length > 0 && <span style={{ color: "#00A9C4", fontSize: 12 }}>({totalApproved})</span>}
            </span>
          ),
          dataIndex: "Quantity",
          key: "quantity",
          width: 120,
          align: "center",
          render: (quantity: number, record: VacationPersonalLeaveRequest) => (record.IsApproved ? quantity : 0),
        },
        {
          title: (
            <span>
              Chờ duyệt {data.length > 0 && <span style={{ color: "#00A9C4", fontSize: 12 }}>({totalPending})</span>}
            </span>
          ),
          dataIndex: "Quantity",
          key: "quantity",
          width: 120,
          align: "center",
          render: (quantity: number, record: VacationPersonalLeaveRequest) => (!record.IsApproved ? quantity || 0 : 0),
        },
      ],
    },
  ];

  return (
    <Table
      bordered
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey="VReg_ID"
      pagination={{
        current,
        pageSize,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`,
        pageSizeOptions: ["10", "20", "50", "100"],
        onChange: (page, size) => {
          setCurrent(page);
          if (size !== pageSize) {
            setPageSize(size);
            setCurrent(1); // Reset về trang đầu khi thay đổi pageSize
          }
        },
        onShowSizeChange: (current, size) => {
          setPageSize(size);
          setCurrent(1); // Reset về trang đầu khi thay đổi pageSize
        },
      }}
    />
  );
};

export default VacationHistoryTable;
export { VacationHistoryTable };
